module.exports = __webpack_public_path__ + "static/media/nam.e2910ec7.webp";